export const CLEAR_SESSION = 'CLEAR_USER_SESSION'
export const SET_SESSION = 'SET_USER_SESSION'
